import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconCrownFilled = createSVG({
    children: (jsx("path", { d: "M2 14.88V6.8q0-.609.54-.889.538-.28 1.029.07l2.858 2.013q.258.165.562.164.328 0 .585-.164l3.864-2.715q.258-.165.562-.164.304 0 .562.164l3.864 2.715q.259.165.562.164.328 0 .585-.164l2.858-2.013q.492-.351 1.03-.07.539.281.539.889v8.079q0 1.663-1.17 2.833-1.173 1.17-2.834 1.171H6.006q-1.662 0-2.833-1.17-1.17-1.172-1.171-2.834z" })),
});

export { IconCrownFilled };
